import type { IconData } from '@stacksjs/iconify-core'

export const screen1Flat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#2859c5\" d=\"M28.794 33.938a.5.5 0 0 0-.496-.438h-8a.5.5 0 0 0-.496.438l-.782 6.248a1.5 1.5 0 0 1-1.488 1.314h-2.85a2.42 2.42 0 0 0-2.297 1.656a1.78 1.78 0 0 0 1.69 2.344H34.52a1.78 1.78 0 0 0 1.69-2.344a2.42 2.42 0 0 0-2.297-1.656h-2.85a1.5 1.5 0 0 1-1.488-1.314z\"/><path fill=\"#8fbffa\" d=\"M8.422 36.084c3.258.203 8.452.416 15.875.416s12.616-.213 15.875-.416c3.236-.201 5.868-2.602 6.174-5.9c.235-2.526.45-6.204.45-11.184s-.215-8.658-.45-11.183c-.306-3.299-2.938-5.7-6.174-5.901c-3.259-.203-8.452-.416-15.875-.416s-12.617.213-15.875.416c-3.236.201-5.868 2.602-6.174 5.9c-.235 2.526-.451 6.204-.451 11.184s.216 8.658.45 11.183c.307 3.299 2.939 5.7 6.175 5.901\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default screen1Flat
